//https://www.npmjs.com/package/use-file-picker#install
import * as React from 'react';
import { IconContext } from "react-icons";
import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import { useFilePicker } from 'use-file-picker';
//import { FileContent } from 'use-file-picker/dist/interfaces';
import {
  FileAmountLimitValidator,
  FileTypeValidator,
  FileSizeValidator,
  ImageDimensionsValidator,
} from 'use-file-picker/validators';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import '@sweetalert2/themes/dark';

const FilePicker = (props: any) => {
  const [myFileName, setMyFileName] = React.useState("");
  const [myFileSrc, setMyFileSrc] = React.useState("");

  const handlePicClick = () => {
    Swal.fire({
      title: "Remove this image?",
      html: "<img id='image-selected-rem' alt='" + myFileName + "' src='" + myFileSrc + "' />",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Keep it!",
      denyButtonText: "Remove"
    }).then((result: { isConfirmed: any; isDenied: any; }) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Image Kept",
          icon: "info",
          toast: true
        });
      } else if (result.isDenied) {
        setMyFileName("");
        setMyFileSrc("");
        clear();
        Swal.fire({
          title: "Image Removed",
          html: "",
          icon: "success",
          toast: true
        });
      }
    });
  }

  const { openFilePicker, loading, clear } = useFilePicker({
    readAs: 'DataURL',
    accept: 'image/*',
    multiple: true,
    validators: [
      new FileAmountLimitValidator({ max: 1 }),
      new FileTypeValidator(['jpg', 'png', 'jpeg']),
      new FileSizeValidator({ maxFileSize: 50 * 1024 * 1024 /* 50 MB */ }),
      new ImageDimensionsValidator({
        maxHeight: 3200, // in pixels
        maxWidth: 3200,
        minHeight: 10,
        minWidth: 10,
      }),
    ],
    onClear: () => {
      console.log("Image cleared");
    },
    onFilesSuccessfullySelected: ({ filesContent }) => {
      setMyFileName(filesContent[0].name);
      setMyFileSrc(filesContent[0].content);
    },
    onFilesRejected: ({ errors }) => {
      console.log(errors);
      Swal.fire({
        title: "Error!",
        html: JSON.stringify(errors[0]),
        icon: "error",
        toast: true
      });
    }
  });

  const CallFilePicker = () => {
    openFilePicker();

    if (loading) {
      Swal.fire({
        title: "",
        html: "loading: " + myFileName,
        toast: true,
        timer: 2000,
        timerProgressBar: true,
        position: 'bottom-end'
      });
    }
  }

  React.useEffect(() => {
    if (props.isImage === false) {
      setMyFileName("");
      setMyFileSrc("");
    }
  }, [props.isImage]);

  if ((myFileName === "" || myFileSrc === "")) {
    return (
      <IconContext.Provider value={{}}>
        <div title="Add photo" id="btnPhoto" onClick={() => CallFilePicker()}><MdOutlineAddPhotoAlternate /></div>
      </IconContext.Provider>
    );
  } else {
    return (
      <>
        {/* {filesContent.map((file, index) => (
          <img id="image-selected" alt={file.name} src={file.content} onClick={() => handlePicClick()} />
        ))}; */}
        <img id="image-selected" alt={myFileName} src={myFileSrc} onClick={handlePicClick} />
      </>
    );
  }
}

export default FilePicker;
